let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("ebebP")]).then(() => parcelRequire('i2nZ3'));